import { ProductInfo } from '@cvent/universal-login-web-graphql/types';

export const coreProducts: Array<ProductInfo> = [
  {
    id: 'cvent',
    label: 'Cvent'
  }
];
